<!-- 企业级-用户管理-会员管理 -->
<template>
  <div class="mainArea CMemberManage">
      
        <div class="searchDiv mt20">
          <div>
            <div class="dib"><el-input placeholder="请输入姓名" v-model="keyword.fullName"></el-input></div>
            <div class="dib"><el-input placeholder="请输入账号" v-model="keyword.account"></el-input></div>
            <el-button type="primary">搜索</el-button>
          </div>
        </div>
        <div class="tableList mt20">
          <el-table :data="memberData" style="width: 100%">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="" label="账号"></el-table-column>
            <el-table-column label="生物特征">
              <template slot-scope="scope">
                <el-button type="text" @click="biosDio=true">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="关联设备">
              <template slot-scope="scope">
                <el-button type="text" @click="equipDio=true">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="" label="创建时间"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <el-button type="text" @click="statusDio = true">正常</el-button>
              </template>
            </el-table-column>
            <el-table-column label="授权用户">
              <template slot-scope="scope">
                <el-button type="text" @click="authoDio = true">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>page">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="page"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      <el-dialog title="生物特征" :visible.sync="biosDio" width="400" class="biosDio">
        <el-tabs v-model="tabNum" @tab-click="handleClick">
          <el-tab-pane label="指纹" name="1">
            <el-form ref="form" :model="form" label-width="60px">
              <el-form-item v-for="(fin,index) in form.finger" :key="index">
                <span slot="label">指纹{{index+1}}:</span>
                <div class="flex">
                  <div class="flexItem">
                    <el-input v-model="fin.fingerprint_id" placeholder="指纹ID"></el-input>
                    <el-input v-model="fin.fingerprint_value" placeholder="指纹特征"></el-input>
                  </div>
                  <i class="el-icon-circle-plus-outline fs25" v-if="index==0" @click="addFinger"></i>
                  <i class="el-icon-remove-outline fs25" v-else @click="delFinger(index)"></i>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="人脸" name="2">
            <el-form ref="form2" :model="form2" label-width="60px">
              <el-form-item label="人脸:">
                <el-upload
                  :action="actionUrl"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="form.dialogImageUrl" alt="">
                </el-dialog>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="员工卡" name="3">
            <el-form ref="form3" :model="form3" label-width="80px">
              <el-form-item v-for="(men,index) in form3.menber" :key="index">
                <span slot="label">员工卡{{index+1}}:</span>
                <div class="flex">
                  <el-input v-model="men[index]"></el-input>
                  <i class="el-icon-circle-plus-outline fs25" v-if="index==0" @click="addMenber"></i>
                  <i class="el-icon-remove-outline fs25" v-else @click="delMenber(index)"></i>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-button type="primary">确认</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <el-dialog title="关联设备" :visible.sync="equipDio" width="480" class="equipDio">
        <div class="dioCont">
          <el-table :data="equipData" style="width: 100%">
            <el-table-column prop="" label="序号"></el-table-column>
            <el-table-column prop="" label="设备ID"></el-table-column>
            <el-table-column prop="" label="设备名称"></el-table-column>
            <el-table-column prop="" label="设备类型"></el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="eq_total>eq_page">
          <el-pagination
            @current-change="eqCurrentChange"
            :current-page.sync="eq_curr"
            :page-size="eq_page"
            layout="prev, pager, next, jumper"
            :total="eq_total">
          </el-pagination>
        </div>
      </el-dialog>
      <el-dialog title="" :visible.sync="statusDio" width="300" class="statusDio">
        <div class="statusCont">
          <div>当前状态为 <b>禁用</b></div>
          <div>是否将状态改为 <b>正常</b>？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary">禁 用</el-button>
        </span>
      </el-dialog>
      <el-dialog title="授权用户" :visible.sync="authoDio" width="480" class="authoDio">
        <div class="dioCont">
          <el-table :data="authData" style="width: 100%">
            <el-table-column prop="" label="序号"></el-table-column>
            <el-table-column prop="" label="姓名"></el-table-column>
            <el-table-column prop="" label="账号"></el-table-column>
            <el-table-column prop="" label="授权时间"></el-table-column>
            <el-table-column prop="" label="创建时间"></el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="eq_total>au_page">
          <el-pagination
            @current-change="auCurrentChange"
            :current-page.sync="au_curr"
            :page-size="au_page"
            layout="prev, pager, next, jumper"
            :total="au_total">
          </el-pagination>
        </div>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../static/js/api.js"


  export default {
    name: 'CMemberManage',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          fullName:'',//姓名
          account:'',//账号
        },
        memberData:[{
          num:1,
          name:'地方'
        }],//会员列表数据

        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        biosDio:false,//生物特征弹窗
        tabNum:'1',//tab默认选中
        form:{
          finger:[{
            fingerprint_id:'',
            fingerprint_value:'',
          }],
        },
        
        dialogVisible: false,
        actionUrl:'https://jsonplaceholder.typicode.com/posts/',
        form2:{
          dialogImageUrl: '',
        },
        form3:{
          menber:[''],
        },

        equipDio:false,//关联设备弹窗
        equipData:[],//关联的设备列表
        //设备分页
        eq_curr:1,//当前页
        eq_page:10,//显示个数
        eq_total:0,//总数据

        statusDio:false,//状态弹窗

        authoDio:false,//授权弹窗
        authData:[],//关联的设备列表
        //授权用户分页
        au_curr:1,//当前页
        au_page:10,//显示个数
        au_total:0,//总数据
      }
    },
    mounted(){
    },
    created: async function () {

    },
    methods: {
      //添加员工卡
      addMenber(){
        this.form3.menber.push('');
      },
      //删除员工卡
      delMenber(index){
        this.form3.menber.splice(index,1);
      },
      //添加指纹
      addFinger(){
        const obj = {
          fingerprint_id:'',
          fingerprint_value:''
        }
        this.form.finger.push(obj);
      },
      //删除指纹
      delFinger(index){
        this.form.finger.splice(index,1);
      },
      //人脸图片文件列表移除文件时的钩子
      handleRemove(file, fileList) {
        // console.log(file, fileList);
      },
      //人脸图片点击文件列表时的钩子
      handlePictureCardPreview(file) {
        this.form2.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      //tab点击
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      //会员分页
      CurrentChange(val) {
        // this.curr = val
        // console.log(`当前页: ${val}`);
      },
      //设备分页
      eqCurrentChange(val) {
        // console.log(`当前页: ${val}`);
      },
      //授权用户分页
      eqCurrentChange(val) {
        // console.log(`当前页: ${val}`);
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
// .mainBodyContent{
//   height: calc(100vh - 194px);
//   overflow-y:auto; 
// }
.CMemberManage{
  .dib{
    display:inline-block;
  }
  .flexItem{
    flex-grow: 1;
  }
  .mt20{
    margin-top:20px;
  }
  .el-dialog__body{
    padding:10px 20px;
  }
  .flex{
    display:flex;
    align-items:center;
  }
  .fs25{
    font-size:25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CUserManege/CMemberManage.vue